import * as React from "react";
import { connect } from "react-redux";
import { selectTopActionButton } from "../../selectors/selectActionButtonInfo";
import { HOCHudComponent } from "../context-menu/HOCHudComponent";
import { HudButton } from "../generic/hud-button/HudButton";
import { actionBuildingsDeselect } from "../player-base/buildings/actionBuildings";
import { actionActionButtonAddIteration } from "./actionHudActionButton";
var _HudActionButton = function (_a) {
    var onClick = _a.onClick, actionButtonInfo = _a.actionButtonInfo;
    if (!actionButtonInfo || !actionButtonInfo.action) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement(HudButton, { icon: actionButtonInfo.icon, onClick: function () { return onClick(actionButtonInfo.action, actionButtonInfo.id); } }));
};
var mapState = function (state) { return ({
    actionButtonInfo: selectTopActionButton(state),
}); };
var mapDispatch = function (dispatch) { return ({
    onClick: function (action, idActionButton) {
        dispatch(actionBuildingsDeselect());
        dispatch(action);
        dispatch(actionActionButtonAddIteration(idActionButton));
    },
}); };
export var HudActionButton = connect(mapState, mapDispatch)(HOCHudComponent(_HudActionButton));



//////////////////
// WEBPACK FOOTER
// ./src/features/hud-action-button/HudActionButton.tsx
// module id = 2286
// module chunks = 3